const translations = {
  button: "Closed chats"
};

export default translations;
